import {
  ref,
  computed,
  watch,
  onUnmounted,
  toValue,
  type Ref,
  type MaybeRefOrGetter,
} from "vue"

export interface BreadcrumbContext {
  dynamicTitle: Ref<string | undefined>
  dynamicLoading: Ref<boolean>
}

const dynamicTitle = ref<string | undefined>(undefined)
const dynamicLoading = ref(false)

export function useBreadcrumbTitle(
  title: MaybeRefOrGetter<string | undefined>,
  loading?: MaybeRefOrGetter<boolean>
) {
  const titleComputed = computed(() => toValue(title))
  const loadingComputed = computed(() => toValue(loading) ?? false)

  watch(
    titleComputed,
    (newTitle) => {
      dynamicTitle.value = newTitle
    },
    { immediate: true }
  )

  watch(
    loadingComputed,
    (newLoading) => {
      dynamicLoading.value = newLoading
    },
    { immediate: true }
  )

  onUnmounted(() => {
    dynamicTitle.value = undefined
    dynamicLoading.value = false
  })

  return { dynamicTitle: titleComputed, dynamicLoading: loadingComputed }
}

export function useBreadcrumbContext(): BreadcrumbContext {
  return {
    dynamicTitle,
    dynamicLoading,
  }
}
